import type { CallStatus, ConnectionStatus, OnlineStatus, VisibilityStatus } from '@/types'

export const ONLINE_STATUS_LABEL: Record<OnlineStatus, string> = {
  offline: 'Offline',
  online: 'Online',
  busy: 'Busy',
}

export const VISIBILITY_STATUS_LABEL: Record<VisibilityStatus, string> = {
  foreground: 'Foreground',
  background: 'Background',
  unknown: 'Unknown',
}

export const CALL_STATUS_LABEL: Record<CallStatus, string> = {
  idle: 'Idle',
  ringing: 'Ringing',
  busy: 'Busy',
}

export const CONNECTION_STATUS_LABEL: Record<ConnectionStatus, string> = {
  disconnected: 'Disconnected',
  connecting: 'Connecting',
  connected: 'Connected',
  reconnecting: 'Reconnecting',
}
